export const footerLinks = {
    'eg-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://eg.wingie.com/flights/to-hurghada/',
                    title: 'الغردقة',
                },
                {
                    href: 'https://eg.wingie.com/flights/to-sohag/',
                    title: 'سوهاج',
                },
                {
                    href: 'https://eg.wingie.com/flights/to-marsa-alam/',
                    title: 'مرسى علم',
                },
                {
                    href: 'https://eg.wingie.com/flights/to-istanbul/',
                    title: 'اسطنبول',
                },
                {
                    href: 'https://eg.wingie.com/flights/to-dubai/',
                    title: 'دبي',
                },
                {
                    href: 'https://eg.wingie.com/flights/to-kuwait/',
                    title: 'الكويت',
                },
            ],
        },
        {
            title: 'أشهر الدول',
            items: [
                {
                    href: 'https://eg.wingie.com/flights/sa-saudi-arabia/',
                    title: 'المملكة العربية السعودية',
                },
                {
                    href: 'https://eg.wingie.com/flights/de-germany/',
                    title: 'ألمانيا',
                },
                {
                    href: 'https://eg.wingie.com/flights/ae-united-arab-emirates/',
                    title: 'الإمارات العربية المتحدة',
                },
                {
                    href: 'https://eg.wingie.com/flights/tr-turkey/',
                    title: 'تركيا',
                },
                {
                    href: 'https://eg.wingie.com/flights/kw-kuwait/',
                    title: 'الكويت',
                },
                {
                    href: 'https://eg.wingie.com/flights/jo-jordan/',
                    title: 'الأردن',
                },
            ],
        },
        {
            title: 'أشهر الخطوط الجوية',
            items: [
                {
                    href: 'https://eg.wingie.com/flights/airlines/egyptair/',
                    title: 'مصر للطيران',
                },
                {
                    href: 'https://eg.wingie.com/flights/airlines/flynas/',
                    title: 'طيران ناس',
                },
                {
                    href: 'https://eg.wingie.com/flights/airlines/royal-jordanian/',
                    title: 'الملكيَّة الأردنيَّة',
                },
                {
                    href: 'https://eg.wingie.com/flights/airlines/air-arabia-egypt/',
                    title: 'العربية للطيران مصر',
                },
                {
                    href: 'https://eg.wingie.com/flights/airlines/air-cairo/',
                    title: 'إير كايرو',
                },
                {
                    href: 'https://eg.wingie.com/flights/airlines/saudi-arabian-airlines/',
                    title: 'السعودية',
                },
            ],
        },
    ],
    'eg-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    href: 'https://eg.wingie.com/en/flights/to-cairo/',
                    title: 'Cairo',
                },
                {
                    href: 'https://eg.wingie.com/en/flights/to-aly-alexandria/',
                    title: 'Alexandria',
                },
                {
                    href: 'https://eg.wingie.com/en/flights/to-sharm-el-sheikh/',
                    title: 'Sharm El Sheikh',
                },
                {
                    href: 'https://eg.wingie.com/en/flights/to-jeddah/',
                    title: 'Jeddah',
                },
                {
                    href: 'https://eg.wingie.com/en/flights/to-dubai/',
                    title: 'Dubai',
                },
                {
                    href: 'https://eg.wingie.com/en/flights/to-riyadh/',
                    title: 'Riyadh',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    href: 'https://eg.wingie.com/en/flights/sa-saudi-arabia/',
                    title: 'Saudi Arabia',
                },
                {
                    href: 'https://eg.wingie.com/en/flights/de-germany/',
                    title: 'Germany',
                },
                {
                    href: 'https://eg.wingie.com/en/flights/ae-united-arab-emirates/',
                    title: 'United Arab Emirates',
                },
                {
                    href: 'https://eg.wingie.com/en/flights/tr-turkey/',
                    title: 'Türkiye',
                },
                {
                    href: 'https://eg.wingie.com/en/flights/kw-kuwait/',
                    title: 'Kuwait',
                },
                {
                    href: 'https://eg.wingie.com/en/flights/jo-jordan/',
                    title: 'Jordan',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    href: 'https://eg.wingie.com/en/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://eg.wingie.com/en/flights/airlines/nile-air/',
                    title: 'Nile Air',
                },
                {
                    href: 'https://eg.wingie.com/en/flights/airlines/air-arabia-egypt/',
                    title: 'Air Arabia Egypt',
                },
                {
                    href: 'https://eg.wingie.com/en/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://eg.wingie.com/en/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://eg.wingie.com/en/flights/airlines/jazeera-airways/',
                    title: 'Jazeera Airways',
                },
            ],
        },
    ],
    'eg-es': [
        {
            title: 'Principales destinos',
            items: [
                {
                    href: 'https://eg.wingie.com/es/vuelos/a-hurghada/',
                    title: 'Hurghada',
                },
                {
                    href: 'https://eg.wingie.com/es/vuelos/a-sohag/',
                    title: 'Sohag',
                },
                {
                    href: 'https://eg.wingie.com/es/vuelos/a-marsa-alam/',
                    title: 'Marsa Alam',
                },
                {
                    href: 'https://eg.wingie.com/es/vuelos/a-estambul/',
                    title: 'Estambul',
                },
                {
                    href: 'https://eg.wingie.com/es/vuelos/a-dubai/',
                    title: 'Dubai',
                },
                {
                    href: 'https://eg.wingie.com/es/vuelos/a-kuwait/',
                    title: 'Kuwait',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    href: 'https://eg.wingie.com/es/vuelos/bh-bahrain/',
                    title: 'Bahréin',
                },
                {
                    href: 'https://eg.wingie.com/es/vuelos/de-germany/',
                    title: 'Alemania',
                },
                {
                    href: 'https://eg.wingie.com/es/vuelos/gr-greece/',
                    title: 'Grecia',
                },
                {
                    href: 'https://eg.wingie.com/es/vuelos/it-italy/',
                    title: 'Italia',
                },
                {
                    href: 'https://eg.wingie.com/es/vuelos/kw-kuwait/',
                    title: 'Kuwait',
                },
                {
                    href: 'https://eg.wingie.com/es/vuelos/lb-lebanon/',
                    title: 'Líbano',
                },
            ],
        },
        {
            title: 'Aerolíneas populares',
            items: [
                {
                    href: 'https://eg.wingie.com/es/vuelos/companias-aereas/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://eg.wingie.com/es/vuelos/companias-aereas/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://eg.wingie.com/es/vuelos/companias-aereas/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
                {
                    href: 'https://eg.wingie.com/es/vuelos/companias-aereas/air-arabia-egypt/',
                    title: 'Air Arabia Egypt',
                },
                {
                    href: 'https://eg.wingie.com/es/vuelos/companias-aereas/air-cairo/',
                    title: 'Air Cairo',
                },
                {
                    href: 'https://eg.wingie.com/es/vuelos/companias-aereas/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
            ],
        },
    ],
    'eg-de': [
        {
            title: 'Top-Destinationen',
            items: [
                {
                    href: 'https://eg.wingie.com/de/flug/nach-hurghada/',
                    title: 'Hurghada',
                },
                {
                    href: 'https://eg.wingie.com/de/flug/nach-sohag/',
                    title: 'Sohag',
                },
                {
                    href: 'https://eg.wingie.com/de/flug/nach-marsa-alam/',
                    title: 'Marsa Alam',
                },
                {
                    href: 'https://eg.wingie.com/de/flug/nach-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://eg.wingie.com/de/flug/nach-dubai/',
                    title: 'Dubai',
                },
                {
                    href: 'https://eg.wingie.com/de/flug/nach-kuwait/',
                    title: 'Kuwait',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://eg.wingie.com/de/flug/bh-bahrain/',
                    title: 'Bahrain',
                },
                {
                    href: 'https://eg.wingie.com/de/flug/de-deutschland/',
                    title: 'Deutschland',
                },
                {
                    href: 'https://eg.wingie.com/de/flug/gr-griechenland/',
                    title: 'Griechenland',
                },
                {
                    href: 'https://eg.wingie.com/de/flug/it-italien/',
                    title: 'Italien',
                },
                {
                    href: 'https://eg.wingie.com/de/flug/kw-kuwait/',
                    title: 'Kuwait',
                },
                {
                    href: 'https://eg.wingie.com/de/flug/lb-libanon/',
                    title: 'Libanon',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://eg.wingie.com/de/flug/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://eg.wingie.com/de/flug/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://eg.wingie.com/de/flug/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
                {
                    href: 'https://eg.wingie.com/de/flug/airlines/air-arabia-egypt/',
                    title: 'Air Arabia Egypt',
                },
                {
                    href: 'https://eg.wingie.com/de/flug/airlines/air-cairo/',
                    title: 'Air Cairo',
                },
                {
                    href: 'https://eg.wingie.com/de/flug/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
            ],
        },
    ],
    'eg-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://eg.wingie.com/ru/flights/to-hurghada/',
                    title: 'Хургада',
                },
                {
                    href: 'https://eg.wingie.com/ru/flights/to-sohag/',
                    title: 'Sohag',
                },
                {
                    href: 'https://eg.wingie.com/ru/flights/to-marsa-alam/',
                    title: 'Марса Алам',
                },
                {
                    href: 'https://eg.wingie.com/ru/flights/to-istanbul/',
                    title: 'Стамбул',
                },
                {
                    href: 'https://eg.wingie.com/ru/flights/to-dubai/',
                    title: 'Дубай',
                },
                {
                    href: 'https://eg.wingie.com/ru/flights/to-kuwait/',
                    title: 'Кувейт',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://eg.wingie.com/ru/flights/bh-bahrain/',
                    title: 'Бахрейн',
                },
                {
                    href: 'https://eg.wingie.com/ru/flights/de-germany/',
                    title: 'Германия',
                },
                {
                    href: 'https://eg.wingie.com/ru/flights/gr-greece/',
                    title: 'Греция',
                },
                {
                    href: 'https://eg.wingie.com/ru/flights/it-italy/',
                    title: 'Италия',
                },
                {
                    href: 'https://eg.wingie.com/ru/flights/kw-kuwait/',
                    title: 'Кувейт',
                },
                {
                    href: 'https://eg.wingie.com/ru/flights/lb-lebanon/',
                    title: 'Ливан',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://eg.wingie.com/ru/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://eg.wingie.com/ru/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://eg.wingie.com/ru/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
                {
                    href: 'https://eg.wingie.com/ru/flights/airlines/air-arabia-egypt/',
                    title: 'Air Arabia Egypt',
                },
                {
                    href: 'https://eg.wingie.com/ru/flights/airlines/air-cairo/',
                    title: 'Air Cairo',
                },
                {
                    href: 'https://eg.wingie.com/ru/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
            ],
        },
    ],
    'eg-it': [
        {
            title: 'Destinazioni Top',
            items: [
                { title: 'Hurghada', href: 'https://eg.wingie.com/it/flights/to-hurghada/' },
                { title: 'Sohag', href: 'https://eg.wingie.com/it/flights/to-sohag/' },
                { title: 'Marsa Alam', href: 'https://eg.wingie.com/it/flights/to-marsa-alam/' },
                { title: 'Istanbul', href: 'https://eg.wingie.com/it/flights/to-istanbul/' },
                { title: 'Dubai', href: 'https://eg.wingie.com/it/flights/to-dubai/' },
                { title: 'Kuwait', href: 'https://eg.wingie.com/it/flights/to-kuwait/' },
            ],
        },
        {
            title: 'Paesi Popolari',
            items: [
                { title: 'Arabia Saudita', href: 'https://eg.wingie.com/it/flights/sa-arabia-saudita/' },
                { title: 'Germania', href: 'https://eg.wingie.com/it/flights/de-germania/' },
                { title: 'Emirati Arabi Uniti', href: 'https://eg.wingie.com/it/flights/ae-emirati-arabi-uniti/' },
                { title: 'Turchia', href: 'https://eg.wingie.com/it/flights/tr-turchia/' },
                { title: 'Kuwait', href: 'https://eg.wingie.com/it/flights/kw-kuwait/' },
                { title: 'Giordania', href: 'https://eg.wingie.com/it/flights/jo-giordania/' },
            ],
        },
        {
            title: 'Compagnie Aeree Popolari',
            items: [
                { title: 'Egyptair', href: 'https://eg.wingie.com/it/flights/airlines/egyptair/' },
                { title: 'Flynas', href: 'https://eg.wingie.com/it/flights/airlines/flynas/' },
                { title: 'Royal Jordanian', href: 'https://eg.wingie.com/it/flights/airlines/royal-jordanian/' },
                { title: 'Air Arabia Egypt', href: 'https://eg.wingie.com/it/flights/airlines/air-arabia-egypt/' },
                { title: 'Air Cairo', href: 'https://eg.wingie.com/it/flights/airlines/air-cairo/' },
                { title: 'Saudi Arabian Airlines', href: 'https://eg.wingie.com/it/flights/airlines/saudi-arabian-airlines/' },
            ],
        },
    ],
    'eg-fr': [
        {
            title: 'Destinations Populaires',
            items: [
                { title: 'Hurghada', href: 'https://eg.wingie.com/fr/flights/to-hurghada/' },
                { title: 'Sohag', href: 'https://eg.wingie.com/fr/flights/to-sohag/' },
                { title: 'Marsa Alam', href: 'https://eg.wingie.com/fr/flights/to-marsa-alam/' },
                { title: 'Istanbul', href: 'https://eg.wingie.com/fr/flights/to-istanbul/' },
                { title: 'Dubaï', href: 'https://eg.wingie.com/fr/flights/to-dubai/' },
                { title: 'Koweït', href: 'https://eg.wingie.com/fr/flights/to-kuwait/' },
            ],
        },
        {
            title: 'Pays Populaires',
            items: [
                { title: 'Arabie Saoudite', href: 'https://eg.wingie.com/fr/flights/sa-arabia-saudita/' },
                { title: 'Allemagne', href: 'https://eg.wingie.com/fr/flights/de-allemagne/' },
                { title: 'Émirats Arabes Unis', href: 'https://eg.wingie.com/fr/flights/ae-emirats-arabes-unis/' },
                { title: 'Turquie', href: 'https://eg.wingie.com/fr/flights/tr-turchia/' },
                { title: 'Koweït', href: 'https://eg.wingie.com/fr/flights/kw-koweit/' },
                { title: 'Jordanie', href: 'https://eg.wingie.com/fr/flights/jo-jordanie/' },
            ],
        },
        {
            title: 'Compagnies Aériennes Populaires',
            items: [
                { title: 'Egyptair', href: 'https://eg.wingie.com/fr/flights/airlines/egyptair/' },
                { title: 'Flynas', href: 'https://eg.wingie.com/fr/flights/airlines/flynas/' },
                { title: 'Royal Jordanian', href: 'https://eg.wingie.com/fr/flights/airlines/royal-jordanian/' },
                { title: 'Air Arabia Egypt', href: 'https://eg.wingie.com/fr/flights/airlines/air-arabia-egypt/' },
                { title: 'Air Cairo', href: 'https://eg.wingie.com/fr/flights/airlines/air-cairo/' },
                { title: 'Saudi Arabian Airlines', href: 'https://eg.wingie.com/fr/flights/airlines/saudi-arabian-airlines/' },
            ],
        },
    ],
    'eg-pt': [
        {
            title: 'Destinos Populares',
            items: [
                { title: 'Hurghada', href: 'https://eg.wingie.com/pt/flights/to-hurghada/' },
                { title: 'Sohag', href: 'https://eg.wingie.com/pt/flights/to-sohag/' },
                { title: 'Marsa Alam', href: 'https://eg.wingie.com/pt/flights/to-marsa-alam/' },
                { title: 'Istambul', href: 'https://eg.wingie.com/pt/flights/to-istanbul/' },
                { title: 'Dubai', href: 'https://eg.wingie.com/pt/flights/to-dubai/' },
                { title: 'Kuwait', href: 'https://eg.wingie.com/pt/flights/to-kuwait/' },
            ],
        },
        {
            title: 'Países Populares',
            items: [
                { title: 'Arábia Saudita', href: 'https://eg.wingie.com/pt/flights/sa-arabia-saudita/' },
                { title: 'Alemanha', href: 'https://eg.wingie.com/pt/flights/de-alemanha/' },
                { title: 'Emirados Árabes Unidos', href: 'https://eg.wingie.com/pt/flights/ae-emirados-arabes-unidos/' },
                { title: 'Turquia', href: 'https://eg.wingie.com/pt/flights/tr-turquia/' },
                { title: 'Kuwait', href: 'https://eg.wingie.com/pt/flights/kw-kuwait/' },
                { title: 'Jordânia', href: 'https://eg.wingie.com/pt/flights/jo-jordania/' },
            ],
        },
        {
            title: 'Companhias Aéreas Populares',
            items: [
                { title: 'Egyptair', href: 'https://eg.wingie.com/pt/flights/airlines/egyptair/' },
                { title: 'Flynas', href: 'https://eg.wingie.com/pt/flights/airlines/flynas/' },
                { title: 'Royal Jordanian', href: 'https://eg.wingie.com/pt/flights/airlines/royal-jordanian/' },
                { title: 'Air Arabia Egypt', href: 'https://eg.wingie.com/pt/flights/airlines/air-arabia-egypt/' },
                { title: 'Air Cairo', href: 'https://eg.wingie.com/pt/flights/airlines/air-cairo/' },
                { title: 'Saudi Arabian Airlines', href: 'https://eg.wingie.com/pt/flights/airlines/saudi-arabian-airlines/' },
            ],
        },
    ],
    'eg-ro': [
        {
            title: 'Destinații Populare',
            items: [
                { title: 'Hurghada', href: 'https://eg.wingie.com/ro/flights/to-hurghada/' },
                { title: 'Sohag', href: 'https://eg.wingie.com/ro/flights/to-sohag/' },
                { title: 'Marsa Alam', href: 'https://eg.wingie.com/ro/flights/to-marsa-alam/' },
                { title: 'Istanbul', href: 'https://eg.wingie.com/ro/flights/to-istanbul/' },
                { title: 'Dubai', href: 'https://eg.wingie.com/ro/flights/to-dubai/' },
                { title: 'Kuwait', href: 'https://eg.wingie.com/ro/flights/to-kuwait/' },
            ],
        },
        {
            title: 'Țări Populare',
            items: [
                { title: 'Arabia Saudită', href: 'https://eg.wingie.com/ro/flights/sa-arabia-saudita/' },
                { title: 'Germania', href: 'https://eg.wingie.com/ro/flights/de-germania/' },
                { title: 'Emiratele Arabe Unite', href: 'https://eg.wingie.com/ro/flights/ae-emiratele-arabe-unite/' },
                { title: 'Turcia', href: 'https://eg.wingie.com/ro/flights/tr-turcia/' },
                { title: 'Kuwait', href: 'https://eg.wingie.com/ro/flights/kw-kuwait/' },
                { title: 'Iordania', href: 'https://eg.wingie.com/ro/flights/jo-iordania/' },
            ],
        },
        {
            title: 'Companii Aeriene Populare',
            items: [
                { title: 'Egyptair', href: 'https://eg.wingie.com/ro/flights/airlines/egyptair/' },
                { title: 'Flynas', href: 'https://eg.wingie.com/ro/flights/airlines/flynas/' },
                { title: 'Royal Jordanian', href: 'https://eg.wingie.com/ro/flights/airlines/royal-jordanian/' },
                { title: 'Air Arabia Egypt', href: 'https://eg.wingie.com/ro/flights/airlines/air-arabia-egypt/' },
                { title: 'Air Cairo', href: 'https://eg.wingie.com/ro/flights/airlines/air-cairo/' },
                { title: 'Saudi Arabian Airlines', href: 'https://eg.wingie.com/ro/flights/airlines/saudi-arabian-airlines/' },
            ],
        },
    ],
    'eg-pl': [
        {
            title: 'Popularne Destynacje',
            items: [
                { title: 'Hurghada', href: 'https://eg.wingie.com/pl/flights/to-hurghada/' },
                { title: 'Sohag', href: 'https://eg.wingie.com/pl/flights/to-sohag/' },
                { title: 'Marsa Alam', href: 'https://eg.wingie.com/pl/flights/to-marsa-alam/' },
                { title: 'Stambuł', href: 'https://eg.wingie.com/pl/flights/to-istanbul/' },
                { title: 'Dubaj', href: 'https://eg.wingie.com/pl/flights/to-dubai/' },
                { title: 'Kuwejt', href: 'https://eg.wingie.com/pl/flights/to-kuwait/' },
            ],
        },
        {
            title: 'Popularne Kraje',
            items: [
                { title: 'Arabia Saudyjska', href: 'https://eg.wingie.com/pl/flights/sa-arabia-saudyjska/' },
                { title: 'Niemcy', href: 'https://eg.wingie.com/pl/flights/de-niemcy/' },
                { title: 'Zjednoczone Emiraty Arabskie', href: 'https://eg.wingie.com/pl/flights/ae-zjednoczone-emiraty-arabskie/' },
                { title: 'Turcja', href: 'https://eg.wingie.com/pl/flights/tr-turcja/' },
                { title: 'Kuwejt', href: 'https://eg.wingie.com/pl/flights/kw-kuwejt/' },
                { title: 'Jordania', href: 'https://eg.wingie.com/pl/flights/jo-jordania/' },
            ],
        },
        {
            title: 'Popularne Linie Lotnicze',
            items: [
                { title: 'Egyptair', href: 'https://eg.wingie.com/pl/flights/airlines/egyptair/' },
                { title: 'Flynas', href: 'https://eg.wingie.com/pl/flights/airlines/flynas/' },
                { title: 'Royal Jordanian', href: 'https://eg.wingie.com/pl/flights/airlines/royal-jordanian/' },
                { title: 'Air Arabia Egypt', href: 'https://eg.wingie.com/pl/flights/airlines/air-arabia-egypt/' },
                { title: 'Air Cairo', href: 'https://eg.wingie.com/pl/flights/airlines/air-cairo/' },
                { title: 'Saudi Arabian Airlines', href: 'https://eg.wingie.com/pl/flights/airlines/saudi-arabian-airlines/' },
            ],
        },
    ],
    'eg-lt': [
        {
            title: 'Populiarūs Kryptys',
            items: [
                { title: 'Hurghada', href: 'https://eg.wingie.com/lt/flights/to-hurghada/' },
                { title: 'Sohag', href: 'https://eg.wingie.com/lt/flights/to-sohag/' },
                { title: 'Marsa Alam', href: 'https://eg.wingie.com/lt/flights/to-marsa-alam/' },
                { title: 'Stambulas', href: 'https://eg.wingie.com/lt/flights/to-istanbul/' },
                { title: 'Dubajus', href: 'https://eg.wingie.com/lt/flights/to-dubai/' },
                { title: 'Kuveitas', href: 'https://eg.wingie.com/lt/flights/to-kuwait/' },
            ],
        },
        {
            title: 'Populiarios Šalys',
            items: [
                { title: 'Saudo Arabija', href: 'https://eg.wingie.com/lt/flights/sa-saudo-arabija/' },
                { title: 'Vokietija', href: 'https://eg.wingie.com/lt/flights/de-vokietija/' },
                { title: 'Jungtiniai Arabų Emyratai', href: 'https://eg.wingie.com/lt/flights/ae-jungtiniai-arabu-emyratai/' },
                { title: 'Turkija', href: 'https://eg.wingie.com/lt/flights/tr-turkija/' },
                { title: 'Kuveitas', href: 'https://eg.wingie.com/lt/flights/kw-kuveitas/' },
                { title: 'Jordanija', href: 'https://eg.wingie.com/lt/flights/jo-jordanija/' },
            ],
        },
        {
            title: 'Populiarios Oro Linijos',
            items: [
                { title: 'Egyptair', href: 'https://eg.wingie.com/lt/flights/airlines/egyptair/' },
                { title: 'Flynas', href: 'https://eg.wingie.com/lt/flights/airlines/flynas/' },
                { title: 'Royal Jordanian', href: 'https://eg.wingie.com/lt/flights/airlines/royal-jordanian/' },
                { title: 'Air Arabia Egypt', href: 'https://eg.wingie.com/lt/flights/airlines/air-arabia-egypt/' },
                { title: 'Air Cairo', href: 'https://eg.wingie.com/lt/flights/airlines/air-cairo/' },
                { title: 'Saudi Arabian Airlines', href: 'https://eg.wingie.com/lt/flights/airlines/saudi-arabian-airlines/' },
            ],
        },
    ],
    'eg-uz': [
        {
            title: "Mashhur Yo'nalishlar",
            items: [
                { title: 'Hurghada', href: 'https://eg.wingie.com/uz/flights/to-hurghada/' },
                { title: 'Sohag', href: 'https://eg.wingie.com/uz/flights/to-sohag/' },
                { title: 'Marsa Alam', href: 'https://eg.wingie.com/uz/flights/to-marsa-alam/' },
                { title: 'Istanbul', href: 'https://eg.wingie.com/uz/flights/to-istanbul/' },
                { title: 'Dubay', href: 'https://eg.wingie.com/uz/flights/to-dubai/' },
                { title: 'Quvayt', href: 'https://eg.wingie.com/uz/flights/to-kuwait/' },
            ],
        },
        {
            title: 'Mashhur Davlatlar',
            items: [
                { title: 'Saudiya Arabistoni', href: 'https://eg.wingie.com/uz/flights/sa-saudiya-arabistoni/' },
                { title: 'Germaniya', href: 'https://eg.wingie.com/uz/flights/de-germaniya/' },
                { title: 'Birlashgan Arab Amirliklari', href: 'https://eg.wingie.com/uz/flights/ae-birlashgan-arab-amirliklari/' },
                { title: 'Turkiya', href: 'https://eg.wingie.com/uz/flights/tr-turkiya/' },
                { title: 'Quvayt', href: 'https://eg.wingie.com/uz/flights/kw-quvayt/' },
                { title: 'Iordaniya', href: 'https://eg.wingie.com/uz/flights/jo-iordaniya/' },
            ],
        },
        {
            title: 'Mashhur Aviakompaniyalar',
            items: [
                { title: 'Egyptair', href: 'https://eg.wingie.com/uz/flights/airlines/egyptair/' },
                { title: 'Flynas', href: 'https://eg.wingie.com/uz/flights/airlines/flynas/' },
                { title: 'Royal Jordanian', href: 'https://eg.wingie.com/uz/flights/airlines/royal-jordanian/' },
                { title: 'Air Arabia Egypt', href: 'https://eg.wingie.com/uz/flights/airlines/air-arabia-egypt/' },
                { title: 'Air Cairo', href: 'https://eg.wingie.com/uz/flights/airlines/air-cairo/' },
                { title: 'Saudi Arabian Airlines', href: 'https://eg.wingie.com/uz/flights/airlines/saudi-arabian-airlines/' },
            ],
        },
    ],
    'eg-sr': [
        {
            title: 'Popularne Destinacije',
            items: [
                { title: 'Hurghada', href: 'https://eg.wingie.com/sr/flights/to-hurghada/' },
                { title: 'Sohag', href: 'https://eg.wingie.com/sr/flights/to-sohag/' },
                { title: 'Marsa Alam', href: 'https://eg.wingie.com/sr/flights/to-marsa-alam/' },
                { title: 'Istanbul', href: 'https://eg.wingie.com/sr/flights/to-istanbul/' },
                { title: 'Dubai', href: 'https://eg.wingie.com/sr/flights/to-dubai/' },
                { title: 'Kuvajt', href: 'https://eg.wingie.com/sr/flights/to-kuwait/' },
            ],
        },
        {
            title: 'Popularne Zemlje',
            items: [
                { title: 'Saudijska Arabija', href: 'https://eg.wingie.com/sr/flights/sa-arabia-saudita/' },
                { title: 'Nemačka', href: 'https://eg.wingie.com/sr/flights/de-nemacka/' },
                { title: 'Ujedinjeni Arapski Emirati', href: 'https://eg.wingie.com/sr/flights/ae-ujedinjeni-arapski-emirati/' },
                { title: 'Turska', href: 'https://eg.wingie.com/sr/flights/tr-turquie/' },
                { title: 'Kuvajt', href: 'https://eg.wingie.com/sr/flights/kw-kuvajt/' },
                { title: 'Jordan', href: 'https://eg.wingie.com/sr/flights/jo-jordan/' },
            ],
        },
        {
            title: 'Popularne Avio-kompanije',
            items: [
                { title: 'Egyptair', href: 'https://eg.wingie.com/sr/flights/airlines/egyptair/' },
                { title: 'Flynas', href: 'https://eg.wingie.com/sr/flights/airlines/flynas/' },
                { title: 'Royal Jordanian', href: 'https://eg.wingie.com/sr/flights/airlines/royal-jordanian/' },
                { title: 'Air Arabia Egypt', href: 'https://eg.wingie.com/sr/flights/airlines/air-arabia-egypt/' },
                { title: 'Air Cairo', href: 'https://eg.wingie.com/sr/flights/airlines/air-cairo/' },
                { title: 'Saudi Arabian Airlines', href: 'https://eg.wingie.com/sr/flights/airlines/saudi-arabian-airlines/' },
            ],
        },
    ],
    'eg-ky': [
        {
            title: 'Популярдуу Багыттар',
            items: [
                { title: 'Хургада', href: 'https://eg.wingie.com/ky/flights/to-hurghada/' },
                { title: 'Сохаг', href: 'https://eg.wingie.com/ky/flights/to-sohag/' },
                { title: 'Марса Алам', href: 'https://eg.wingie.com/ky/flights/to-marsa-alam/' },
                { title: 'Стамбул', href: 'https://eg.wingie.com/ky/flights/to-istanbul/' },
                { title: 'Дубай', href: 'https://eg.wingie.com/ky/flights/to-dubai/' },
                { title: 'Кувейт', href: 'https://eg.wingie.com/ky/flights/to-kuwait/' },
            ],
        },
        {
            title: 'Популярдуу Өлкөлөр',
            items: [
                { title: 'Сауд Арабиясы', href: 'https://eg.wingie.com/ky/flights/sa-arabia-saudita/' },
                { title: 'Германия', href: 'https://eg.wingie.com/ky/flights/de-germaniya/' },
                { title: 'Греция', href: 'https://eg.wingie.com/ky/flights/gr-gretsiya/' },
                { title: 'Түркия', href: 'https://eg.wingie.com/ky/flights/tr-turska/' },
                { title: 'Кувейт', href: 'https://eg.wingie.com/ky/flights/kw-kuwait/' },
                { title: 'Иордания', href: 'https://eg.wingie.com/ky/flights/jo-jordan/' },
            ],
        },
        {
            title: 'Популярдуу Авиакомпаниялар',
            items: [
                { title: 'Egyptair', href: 'https://eg.wingie.com/ky/flights/airlines/egyptair/' },
                { title: 'Flynas', href: 'https://eg.wingie.com/ky/flights/airlines/flynas/' },
                { title: 'Royal Jordanian', href: 'https://eg.wingie.com/ky/flights/airlines/royal-jordanian/' },
                { title: 'Air Arabia Egypt', href: 'https://eg.wingie.com/ky/flights/airlines/air-arabia-egypt/' },
                { title: 'Air Cairo', href: 'https://eg.wingie.com/ky/flights/airlines/air-cairo/' },
                { title: 'Saudi Arabian Airlines', href: 'https://eg.wingie.com/ky/flights/airlines/saudi-arabian-airlines/' },
            ],
        },
    ],
    'eg-tg': [
        {
            title: 'Масҳуртарин Самтҳо',
            items: [
                { title: 'Хургада', href: 'https://eg.wingie.com/tg/flights/to-hurghada/' },
                { title: 'Сохаг', href: 'https://eg.wingie.com/tg/flights/to-sohag/' },
                { title: 'Марса Алам', href: 'https://eg.wingie.com/tg/flights/to-marsa-alam/' },
                { title: 'Истанбул', href: 'https://eg.wingie.com/tg/flights/to-istanbul/' },
                { title: 'Дубай', href: 'https://eg.wingie.com/tg/flights/to-dubai/' },
                { title: 'Кувайт', href: 'https://eg.wingie.com/tg/flights/to-kuwait/' },
            ],
        },
        {
            title: 'Масҳуртарин Кишварҳо',
            items: [
                { title: 'Арабистони Саудӣ', href: 'https://eg.wingie.com/tg/flights/sa-arabistoni-saudi/' },
                { title: 'Олмон', href: 'https://eg.wingie.com/tg/flights/de-olmon/' },
                { title: 'Эмиротҳои Муттаҳидаи Араб', href: 'https://eg.wingie.com/tg/flights/ae-amorathoi-muttahidai-arab/' },
                { title: 'Туркия', href: 'https://eg.wingie.com/tg/flights/tr-turkiya/' },
                { title: 'Кувайт', href: 'https://eg.wingie.com/tg/flights/kw-kuwait/' },
                { title: 'Урдун', href: 'https://eg.wingie.com/tg/flights/jo-jordan/' },
            ],
        },
        {
            title: 'Масҳуртарин Авиакомпанияҳо',
            items: [
                { title: 'Egyptair', href: 'https://eg.wingie.com/tg/flights/airlines/egyptair/' },
                { title: 'Flynas', href: 'https://eg.wingie.com/tg/flights/airlines/flynas/' },
                { title: 'Royal Jordanian', href: 'https://eg.wingie.com/tg/flights/airlines/royal-jordanian/' },
                { title: 'Air Arabia Egypt', href: 'https://eg.wingie.com/tg/flights/airlines/air-arabia-egypt/' },
                { title: 'Air Cairo', href: 'https://eg.wingie.com/tg/flights/airlines/air-cairo/' },
                { title: 'Saudi Arabian Airlines', href: 'https://eg.wingie.com/tg/flights/airlines/saudi-arabian-airlines/' },
            ],
        },
    ],
    'eg-kk': [
        {
            title: 'Танымал Бағыттар',
            items: [
                { title: 'Хургада', href: 'https://eg.wingie.com/kk/flights/to-hurghada/' },
                { title: 'Сохаг', href: 'https://eg.wingie.com/kk/flights/to-sohag/' },
                { title: 'Марса Алам', href: 'https://eg.wingie.com/kk/flights/to-marsa-alam/' },
                { title: 'Стамбул', href: 'https://eg.wingie.com/kk/flights/to-istanbul/' },
                { title: 'Дубай', href: 'https://eg.wingie.com/kk/flights/to-dubai/' },
                { title: 'Кувейт', href: 'https://eg.wingie.com/kk/flights/to-kuwait/' },
            ],
        },
        {
            title: 'Танымал Елдер',
            items: [
                { title: 'Сауд Арабиясы', href: 'https://eg.wingie.com/kk/flights/sa-saudy-arabiyasy/' },
                { title: 'Германия', href: 'https://eg.wingie.com/kk/flights/de-germaniya/' },
                { title: 'Біріккен Араб Эмираттары', href: 'https://eg.wingie.com/kk/flights/ae-birikken-arab-emirattary/' },
                { title: 'Түркия', href: 'https://eg.wingie.com/kk/flights/tr-turska/' },
                { title: 'Кувейт', href: 'https://eg.wingie.com/kk/flights/kw-kuwait/' },
                { title: 'Иордания', href: 'https://eg.wingie.com/kk/flights/jo-jordan/' },
            ],
        },
        {
            title: 'Танымал Авиакомпаниялар',
            items: [
                { title: 'Egyptair', href: 'https://eg.wingie.com/kk/flights/airlines/egyptair/' },
                { title: 'Flynas', href: 'https://eg.wingie.com/kk/flights/airlines/flynas/' },
                { title: 'Royal Jordanian', href: 'https://eg.wingie.com/kk/flights/airlines/royal-jordanian/' },
                { title: 'Air Arabia Egypt', href: 'https://eg.wingie.com/kk/flights/airlines/air-arabia-egypt/' },
                { title: 'Air Cairo', href: 'https://eg.wingie.com/kk/flights/airlines/air-cairo/' },
                { title: 'Saudi Arabian Airlines', href: 'https://eg.wingie.com/kk/flights/airlines/saudi-arabian-airlines/' },
            ],
        },
    ],
    'eg-nl': [
        {
            title: 'Populaire Bestemmingen',
            items: [
                { title: 'Hurghada', href: 'https://eg.wingie.com/nl/flights/to-hurghada/' },
                { title: 'Sohag', href: 'https://eg.wingie.com/nl/flights/to-sohag/' },
                { title: 'Marsa Alam', href: 'https://eg.wingie.com/nl/flights/to-marsa-alam/' },
                { title: 'Istanbul', href: 'https://eg.wingie.com/nl/flights/to-istanbul/' },
                { title: 'Dubai', href: 'https://eg.wingie.com/nl/flights/to-dubai/' },
                { title: 'Koeweit', href: 'https://eg.wingie.com/nl/flights/to-kuwait/' },
            ],
        },
        {
            title: 'Populaire Landen',
            items: [
                { title: 'Saoedi-Arabië', href: 'https://eg.wingie.com/nl/flights/sa-saoedi-arabie/' },
                { title: 'Duitsland', href: 'https://eg.wingie.com/nl/flights/de-duitsland/' },
                { title: 'Verenigde Arabische Emiraten', href: 'https://eg.wingie.com/nl/flights/ae-verenigde-arabische-emiraten/' },
                { title: 'Turkije', href: 'https://eg.wingie.com/nl/flights/tr-turkije/' },
                { title: 'Koeweit', href: 'https://eg.wingie.com/nl/flights/kw-koeweit/' },
                { title: 'Jordanië', href: 'https://eg.wingie.com/nl/flights/jo-jordanie/' },
            ],
        },
        {
            title: 'Populaire Luchtvaartmaatschappijen',
            items: [
                { title: 'Egyptair', href: 'https://eg.wingie.com/nl/flights/airlines/egyptair/' },
                { title: 'Flynas', href: 'https://eg.wingie.com/nl/flights/airlines/flynas/' },
                { title: 'Royal Jordanian', href: 'https://eg.wingie.com/nl/flights/airlines/royal-jordanian/' },
                { title: 'Air Arabia Egypt', href: 'https://eg.wingie.com/nl/flights/airlines/air-arabia-egypt/' },
                { title: 'Air Cairo', href: 'https://eg.wingie.com/nl/flights/airlines/air-cairo/' },
                { title: 'Saudi Arabian Airlines', href: 'https://eg.wingie.com/nl/flights/airlines/saudi-arabian-airlines/' },
            ],
        },
    ],
    'eg-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://eg.wingie.com/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://eg.wingie.com/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://eg.wingie.com/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://eg.wingie.com/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://eg.wingie.com/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://eg.wingie.com/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://eg.wingie.com/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://eg.wingie.com/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://eg.wingie.com/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://eg.wingie.com/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://eg.wingie.com/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://eg.wingie.com/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://eg.wingie.com/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://eg.wingie.com/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://eg.wingie.com/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://eg.wingie.com/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://eg.wingie.com/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://eg.wingie.com/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'eg-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://eg.wingie.com/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://eg.wingie.com/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://eg.wingie.com/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://eg.wingie.com/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://eg.wingie.com/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://eg.wingie.com/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://eg.wingie.com/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://eg.wingie.com/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://eg.wingie.com/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://eg.wingie.com/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://eg.wingie.com/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://eg.wingie.com/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://eg.wingie.com/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://eg.wingie.com/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://eg.wingie.com/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://eg.wingie.com/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://eg.wingie.com/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://eg.wingie.com/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'eg-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://eg.wingie.com/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://eg.wingie.com/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://eg.wingie.com/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://eg.wingie.com/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://eg.wingie.com/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://eg.wingie.com/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://eg.wingie.com/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://eg.wingie.com/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://eg.wingie.com/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://eg.wingie.com/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://eg.wingie.com/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://eg.wingie.com/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://eg.wingie.com/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://eg.wingie.com/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://eg.wingie.com/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://eg.wingie.com/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://eg.wingie.com/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://eg.wingie.com/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'eg-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://eg.wingie.com/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://eg.wingie.com/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://eg.wingie.com/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://eg.wingie.com/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://eg.wingie.com/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://eg.wingie.com/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://eg.wingie.com/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://eg.wingie.com/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://eg.wingie.com/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://eg.wingie.com/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://eg.wingie.com/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://eg.wingie.com/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://eg.wingie.com/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://eg.wingie.com/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://eg.wingie.com/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://eg.wingie.com/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://eg.wingie.com/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://eg.wingie.com/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'eg-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://eg.wingie.com/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://eg.wingie.com/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://eg.wingie.com/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://eg.wingie.com/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://eg.wingie.com/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://eg.wingie.com/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://eg.wingie.com/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://eg.wingie.com/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://eg.wingie.com/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://eg.wingie.com/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://eg.wingie.com/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://eg.wingie.com/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://eg.wingie.com/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://eg.wingie.com/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://eg.wingie.com/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://eg.wingie.com/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://eg.wingie.com/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://eg.wingie.com/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'eg-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://eg.wingie.com/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://eg.wingie.com/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://eg.wingie.com/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://eg.wingie.com/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://eg.wingie.com/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://eg.wingie.com/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://eg.wingie.com/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://eg.wingie.com/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://eg.wingie.com/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://eg.wingie.com/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://eg.wingie.com/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://eg.wingie.com/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://eg.wingie.com/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://eg.wingie.com/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://eg.wingie.com/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://eg.wingie.com/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://eg.wingie.com/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://eg.wingie.com/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'eg-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://eg.wingie.com/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://eg.wingie.com/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://eg.wingie.com/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://eg.wingie.com/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://eg.wingie.com/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://eg.wingie.com/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://eg.wingie.com/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://eg.wingie.com/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://eg.wingie.com/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://eg.wingie.com/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://eg.wingie.com/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://eg.wingie.com/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://eg.wingie.com/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://eg.wingie.com/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://eg.wingie.com/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://eg.wingie.com/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://eg.wingie.com/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://eg.wingie.com/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'eg-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://eg.wingie.com/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://eg.wingie.com/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://eg.wingie.com/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://eg.wingie.com/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://eg.wingie.com/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://eg.wingie.com/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://eg.wingie.com/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://eg.wingie.com/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://eg.wingie.com/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://eg.wingie.com/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://eg.wingie.com/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://eg.wingie.com/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://eg.wingie.com/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://eg.wingie.com/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://eg.wingie.com/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://eg.wingie.com/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://eg.wingie.com/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://eg.wingie.com/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}